module.exports = __webpack_public_path__ + "static/media/placeholder.ffe33250.svg";